import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';

export const PageLoaderWrapper = styled(Box)({
  position        : 'absolute',
  top             : '50%',
  left            : '50%',
  MozTransform    : 'translateX(-50%) translateY(-50%)',
  WebkitTransform : 'translateX(-50%) translateY(-50%)',
  transform       : 'translateX(-50%) translateY(-50%)',
});

export const PageLoader = styled(CircularProgress)(({ theme }) => ({
  display : 'flex',
  color   : theme.palette.primary.blue1,
}));
